import CallsFilter from "./CallsFilter";
export const PaginationAndFilter = ({hasNext, hasPrevious, goPrevious, goNext, isLoading, isError, ...filters}) =>
    <div className="sidebar-controls">
        <details className="filter-section">
            <summary>Filters</summary>
            <CallsFilter {...filters}/>
        </details>
        <nav className="pagination-row" aria-label="Calls pagination">
            <button type="button" onClick={goPrevious} disabled={!hasPrevious || isLoading}>‹ Previous</button>
            <button type="button" onClick={goNext} disabled={!hasNext || isLoading}>Next ›</button>
        </nav>
        <p className="calls-loading-status" role="status">{isLoading ? "Loading calls…" : ""}</p>
        {isError && <p className="panel-message" role="alert">Unable to load calls. Please try again.</p>}
    </div>;
